import { broker } from 'modules/TradingChart/consts';
import {
  PositionBase,
  PositionLiveUpdate,
  PositionV3,
} from 'modules/TradesPW3/Positions/typings';
import { POSITION_TYPE } from 'modules/TradesPW3/Positions/constants';
import WsPortfolioV2Feeder from '../../WebSocket/modules/PortfolioV2/store';
import PositionsService from './positions';
import positionsTVService from './PositionsTvService';

class PositionsServiceUpdater {
  static registerPositionsUpdater() {
    WsPortfolioV2Feeder.registerHandler(
      'position_update',
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async (response: { data: PositionLiveUpdate }) => {
        if (!response?.data?.data) return;

        const { data } = response.data;
        const updatedPosition = PositionsService.formatLivePositionData(
          data as PositionV3,
        );
        const updatedPositionId = PositionsService.generatePositionUniqueId(
          updatedPosition,
        );
        const positions = [...PositionsService.positions];

        // Update position in STORE
        const indexOfUpdatedPosition = positions.findIndex(
          position =>
            updatedPositionId ===
            PositionsService.generatePositionUniqueId(position),
        );

        const modifiedPosition = await PositionsService.modifyPosition(
          updatedPosition,
        );

        if (indexOfUpdatedPosition >= 0) {
          positions[indexOfUpdatedPosition] = modifiedPosition;
          PositionsService.setPositions(positions);
        } else {
          PositionsService.setPositions([modifiedPosition, ...positions]);
          // This may be new scrip - that is why we have to subscribe for it
          positionsTVService.subscribeForScrips([modifiedPosition]);
        }

        this.updateTVPosition(modifiedPosition);
      },
    );
  }

  private static updateTVPosition = (position: PositionBase) => {
    if (broker.instance) {
      const formattedPosition = positionsTVService.formatPositionToTVTable(
        position,
      );

      const positionType = PositionsService.getPositionType(position);

      if (positionType === POSITION_TYPE.Opened) {
        broker.instance.updateOpenPositions([formattedPosition]);
        broker.instance.plUpdate(formattedPosition.id, formattedPosition.pnl);
      } else {
        broker.instance.updateClosedPositions([formattedPosition]);

        // It is strange solution, but removing of open position
        // can be done only passing qty === 0 along with other properties.
        // This solution has been taken from chat with TV developer
        broker.instance.updateOpenPositions([{ ...formattedPosition, qty: 0 }]);
      }

      broker.instance.updatePositionsPnL();
    }
  };
}

export default PositionsServiceUpdater;
